import VueRouter from "vue-router";
import Vue from 'vue'
import Table from '@/components/table.vue'
import ManageCategory from '@/components/manage_category.vue'
import ManageProduct from '@/components/manage_product.vue'
import ManageUser from '@/components/manage_user.vue'
import Match from '@/components/match.vue'
import ManageCarry from '@/components/others/manage_carry.vue'
import ManageDriver from '@/components/others/manage_driver.vue'
import ManagePayee from '@/components/others/manage_payee.vue'
import ManageAddr from '@/components/others/manage_addr.vue'
import Login from '@/components/login.vue'
import Userinfo from '@/components/userinfo.vue'
import ManageOrder from '@/components/manage_order.vue'
import OrderDetail from '@/components/order_detail.vue'
import ManageRepair from '@/components/manage_repair.vue'
import ManageGround from '@/components/others/manage_ground.vue'
import ManageOwner from '@/components/others/manage_owner.vue'
import ManageStock from '@/components/manage_stock.vue'

Vue.use(VueRouter)

const router = new VueRouter({
	routes: [
		{path: '/Table', component: Table},
		{path: '/ManageCategory', component: ManageCategory},
		{path: '/ManagePayee', component: ManagePayee},
		{path: '/ManageDriver', component: ManageDriver},
		{path: '/ManageCarry', component: ManageCarry},
		{path: '/ManageAddr', component: ManageAddr},
		{path: '/match', component: Match},
		{path: '/ManageUser', component: ManageUser},
		{path: '/ManageProduct', component: ManageProduct},
		{path: '/Login', component: Login},
		{path: '/Userinfo', component: Userinfo},
		{path: '/ManageOrder', component: ManageOrder},
		{path: '/OrderDetail', component: OrderDetail},
		{path: '/ManageRepair', component: ManageRepair},
		{path: '/ManageGround', component: ManageGround},
		{path: '/ManageOwner', component: ManageOwner},
		{path: '/ManageStock', component: ManageStock}
	]
})

export default router